import {
	db,
	DEBUG,
	toaster,
	DBType,
	RestAPI,
	IRestResult,
	IRestParams,
	IRestDeleteParams,
	IErrorRestResponse,
	IRestCollectionParams,
	InsertOrUpdateManyPayload,
	VIPCapabilityCertificate,
	IVIPCapabilityCertificate,
	IVIPCapabilityCertificateOptions,
	staticImplements,
	IEntityRest,
	VIPCapabilityCertificateFields,
} from "@/loader";
import axios, { AxiosError } from "axios";

export interface IVIPCapabilityCertificateRestGetParams extends IRestParams {
	options?: IVIPCapabilityCertificateOptions;
}

export interface IVIPCapabilityCertificateRestCollectionParams extends IRestCollectionParams, IVIPCapabilityCertificateRestGetParams  {
	orderby?: VIPCapabilityCertificateFields | VIPCapabilityCertificateFields[];
	fk_capability?: number;
	fk_certificate?: number;
}

@staticImplements<IEntityRest<IVIPCapabilityCertificate, VIPCapabilityCertificate>>()
export abstract class VIPCapabilityCertificateRest {
	public static readonly endpoint: string = "capabilities/{fk_capability}/certificates";

	public static getURL(data?: IVIPCapabilityCertificate, singular: boolean = false): string {
		let url: string[] = [RestAPI.url.replace(/\/$/, ""), RestAPI.namespace];
		if (data?.fk_capability) {
			url.push(VIPCapabilityCertificateRest.endpoint.replace("{fk_capability}", data.fk_capability.toString()));
			if (singular && data?.fk_certificate) {
				url.push(data.fk_certificate.toString());
			}
		}
		return url.join("/");
	}

	public static async list(fk_capability: number, params?: IVIPCapabilityCertificateRestCollectionParams): Promise<IRestResult<VIPCapabilityCertificate>> {
		return await RestAPI.list<IVIPCapabilityCertificate, VIPCapabilityCertificate>(VIPCapabilityCertificateRest.getURL({ fk_capability }), DBType.capabilityCertificates, params);
	}

	public static async get(data: IVIPCapabilityCertificate, params?: IVIPCapabilityCertificateRestGetParams): Promise<IRestResult<VIPCapabilityCertificate>> {
		return await RestAPI.get<IVIPCapabilityCertificate, VIPCapabilityCertificate>(VIPCapabilityCertificateRest.getURL(data, true), DBType.capabilityCertificates, params);
	}

	public static async create(data: IVIPCapabilityCertificate): Promise<IRestResult<VIPCapabilityCertificate>> {
		return await RestAPI.post<IVIPCapabilityCertificate, VIPCapabilityCertificate>(VIPCapabilityCertificateRest.getURL(data), data, DBType.capabilityCertificates);
	}

	public static async update(data: IVIPCapabilityCertificate): Promise<IRestResult<VIPCapabilityCertificate>> {
		return await RestAPI.post<IVIPCapabilityCertificate, VIPCapabilityCertificate>(VIPCapabilityCertificateRest.getURL(data, true), data, DBType.capabilityCertificates);
	}

	public static async delete(data: IVIPCapabilityCertificate, params?: IRestDeleteParams): Promise<IRestResult<VIPCapabilityCertificate>> {
		return await RestAPI.delete<IVIPCapabilityCertificate, VIPCapabilityCertificate>(VIPCapabilityCertificateRest.getURL(data, true), DBType.capabilityCertificates, params);
	}

	public static async batch(fk_capability: number, data: number[]): Promise<IRestResult<VIPCapabilityCertificate[]>> {
		return await axios.post<VIPCapabilityCertificate[]>(VIPCapabilityCertificateRest.getURL({ fk_capability }) + "/batch", { ids: data })
			.then(response => {
				let payload: InsertOrUpdateManyPayload<IVIPCapabilityCertificate, VIPCapabilityCertificate> = { items: response.data, type: DBType.capabilityCertificates };
				db.insertOrUpdateMany(payload);
				return <IRestResult<VIPCapabilityCertificate[]>>{ success: true, items: payload.result };
			}).catch((error: AxiosError<IErrorRestResponse>) => {
				if (DEBUG) {
					console.log(error.response?.data);
				}
				toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
				return <IRestResult<VIPCapabilityCertificate[]>>{ success: false, error: error.response?.data };
			});
	}
}
